import React, { useState } from "react";
import { getMaskedEmailByMobile} from "./authService";

const EnterMobile: React.FC<{ onNext: (mobile: string, maskedEmail: string) => void }> = ({ onNext }) => {
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    try {
      const { success,data } = await  getMaskedEmailByMobile(mobile);
      onNext(mobile, data);
    } catch (err: any) {
      setError(err.response?.data || "Invalid mobile number");
    }
  };

  return (
    
    <div className="modal-content">
      <div className="modal-header border-bottom-0 row">
       <button type="button" className="btn-close"  data-bs-dismiss="modal" aria-label="Close"></button>
       <h5 className="cme-header">Forgot Password</h5></div>
        <div className="modal-body pb-5">    
          <label>Mobile Number : </label>
      <input
        type="text"
        placeholder="Enter Mobile Number"
        value={mobile}
        onChange={(e) => setMobile(e.target.value)}
      />
      <button onClick={handleSubmit}>Submit</button>
      {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
    </div>
  );
};

export default EnterMobile;
